import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';
import { reportsGuard } from './core/guards/reports.guard';

export const routes: Routes = [
  // Ruta por defecto (estilo rex-web)
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  // Rutas de autenticación
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes')
      .then(m => m.AUTH_ROUTES)
  },
  // Rutas protegidas que requieren autenticación
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./core/components/layout/layout.component')
      .then(m => m.LayoutComponent),
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component')
          .then(m => m.DashboardComponent)
      },
      {
        path: 'accounts',
        loadChildren: () => import('./features/accounts/accounts.routes')
          .then(m => m.ACCOUNTS_ROUTES)
      },
      {
        path: 'roles',
        loadChildren: () => import('./features/roles/roles.routes')
          .then(m => m.ROLES_ROUTES)
      },
      {
        path: 'permissions',
        loadChildren: () => import('./features/permissions/permissions.routes')
          .then(m => m.PERMISSIONS_ROUTES)
      },
      {
        path: 'products',
        loadChildren: () => import('./features/products/products.routes')
          .then(m => m.PRODUCTS_ROUTES)
      },
      {
        path: 'audit',
        canActivate: [adminGuard],
        loadChildren: () => import('./features/audit/audit.routes')
          .then(m => m.AUDIT_ROUTES)
      },
      {
        path: 'reports',
        canActivate: [reportsGuard],
        loadChildren: () => import('./features/reports/reports.routes')
          .then(m => m.REPORTS_ROUTES)
      }
    ]
  },
  // Ruta wildcard
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];